import React, { useState, useEffect } from "react";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { AdminMenus } from "../../../components/recoil/atoms/Menus";

import Header from "../../components/includes/Header";
import Paging from "../../components/includes/Paging";
import SalesSearch from "../../components/sales/SalesSearch";
import SalesSearchResult from "../../components/sales/SalesSearchResult";
import {LoginAfterCheckLogin, addThousandPoint,GetSalesMonthString} from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";


//매츨 관리
const SalesList = () => {
  LoginAfterCheckLogin(0);  //로그인 상태 점검

  const [varAdminMenus,setAdminMenus] = useRecoilState(AdminMenus);

  //컬럼기본
  let columnList = [
      {Header:'번호',accessor:'nums',width:50},
      {Header:'센터명',accessor:'bh_company',width:100},
      {Header:'매출월',accessor:'speriod',width:70},
      {Header:'마마몽떼 로열티',accessor:'m_royalty',width:70},
      {Header:'마마몽떼 청구인원',accessor:'m_childrens',width:70},
      {Header:'총 마마몽떼 로열티',accessor:'t_m_royalty',width:80},
      {Header:'플라이 로열티',accessor:'f_royalty',width:60},
      {Header:'플라이 청구인원',accessor:'f_childrens',width:65},
      {Header:'총 플라이 로열티',accessor:'t_f_royalty',width:70},
      {Header:'총 월별 로열티',accessor:'t_royalty',width:100},
      {Header:'총 청구인원',accessor:'t_childrens',width:60},
      {Header:'고유번호1',accessor:'bh_idx',width:20},
      {Header:'검색월',accessor:'sterms',width:20}
  ];
  const [varColumnLists,setColumnLists] = useState([]);

  //매츨 목록
  const [varSalesLists,setSalesLists] = useState([]);
  //센터 목록
  const [varBranchList,setBranchList] = useState([]);
  //검색년도
  const [varYearList, setYearList] = useState([]);
  //검색월
  const [varMonthList, setMonthList] = useState([]);

  //검색
  const [varSearchData, setSearchData] = useState({
    sdate:null,
    edate:null,
    searchBranch:0,
    searchYear:0,
    searchMonth:0
  });

  //페이지
  const [varTotalState, setTotalState] = useState(0);
  const [varPageSize] = useState(10);
  const [varPageNum, setPageNum] = useState(1);
  
  //매츨 목록 읽어오기
  const getSalesList = async () => {
    const sendData = {pageNum: varPageNum,pageSize: varPageSize,searchData: varSearchData};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_sales_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        let totalcount = datas.tcount;
        let totalamount = datas.tamount;
        
        let newArray = [];
        let branch = "센터 전체";
        const pmax = totalcount - (varPageNum - 1) * varPageSize;
        if(pmax > 0) {
          const dataArray = datas.results;
          if(varSearchData.searchBranch > 0) branch = dataArray[0].bh_company;
          for(var i=0; i < dataArray.length; i++) {
            const lineObj = dataArray[i];
            var newData = {};
            newData['nums'] = pmax - i;
            newData['bh_company'] = lineObj.bh_company;
            newData['speriod'] = GetSalesMonthString(lineObj.ph_pdate,1);
            newData['m_royalty'] = lineObj.m_childrens>0?lineObj.m_ry_name:"-";
            newData['m_childrens'] = lineObj.m_childrens;
            newData['t_m_royalty'] = addThousandPoint(lineObj.t_m_royalty);
            newData['f_royalty'] = lineObj.f_childrens> 0?lineObj.f_ry_name:"-";
            newData['f_childrens'] = lineObj.f_childrens;
            newData['t_f_royalty'] = addThousandPoint(lineObj.t_f_royalty);
            newData['t_royalty'] = addThousandPoint(lineObj.t_m_royalty+lineObj.t_f_royalty);
            newData['t_childrens'] = lineObj.m_childrens+lineObj.f_childrens;
            newData['bh_idx'] = lineObj.bh_idx;
            newData['sterms'] = lineObj.sterms;
            newArray.push(newData);
          }
        } else {
          if(varSearchData.searchBranch > 0){
            let newData = datas.branchs.find(el=>el.bh_idx === varSearchData.searchBranch);
            branch = newData.bh_company;
          } 
        }
        setTotalState({totalcount:totalcount,totalamount:totalamount,branch:branch});
        console.log(newArray);
        setSalesLists(newArray);
        setBranchList(datas.branchs);
      } else {
        setSalesLists([]);
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setAdminMenus({type:'SALES',item:'SalesReport'});
    console.log(varAdminMenus);
    setColumnLists(columnList);

    const ndate = new Date();
    /* const cyear = ndate.getFullYear();
    const cmonth = ndate.getMonth()+1; */

    //년도배열
    const nYear = ndate.getFullYear();
    let ayears = [];
    for(var i=0; i <10; i++) {
      ayears.push(nYear-i);
    }
    setYearList(ayears);
    //월배열
    let amonth = [];
    for(var j=1; j <12; j++) {
      amonth.push(j);
    }
    setMonthList(amonth);
    //setSearchData({...varSearchData,searchYear:cyear,searchMonth:cmonth});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getSalesList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varPageNum,varSearchData]);

  return varColumnLists.length===0?null:(
    <div id="admin_contents" className="adm_contents">
      <Header varTitle={"매출 리포트"} varDirection={'매출 리포트'}/>
      <div className="admin-content">
        <SalesSearch varSearchData={varSearchData} setSearchData={setSearchData} setPageNum={setPageNum} varBranchList={varBranchList} 
                        varYearList={varYearList} varMonthList={varMonthList} />
        <SalesSearchResult varTotalState={varTotalState} varColumnLists={varColumnLists} varSearchData={varSearchData}
                        varSalesLists={varSalesLists} />
        <div className="paging" style={{ marginBottom: "20px" }}>
          <Paging totalCount={varTotalState.totalcount} pageSize={varPageSize} curPage={varPageNum} setPage={setPageNum} />
        </div>
      </div>
    </div>
  );
}
export default SalesList;